import React from 'react'
import { Redirect } from 'react-router-dom'
import { Query } from 'react-apollo'
import get from 'lodash/get'

import { Loader } from '../containers/Loader'
import { URLS } from '../constants'
import ME_QUERY from '../graphql/MeQuery.graphql'

import { authenticate, setUser, getPathBeforeAuthOrDefaultToDashboard } from '../utils'

const SlackSignInSuccess = () => {
  const params = new URL(document.location).searchParams
  const token = params.get('token')
  authenticate(token)

  return (
    <Query query={ME_QUERY}>
      {({ loading, data }) => {
        if (loading) {
          return <Loader />
        }
        const me = get(data, 'me', {})
        if (!me) {
          return <Redirect to={URLS.SLACK_LOGIN_DENIED} />
        }
        setUser(me)
        return <Redirect to={getPathBeforeAuthOrDefaultToDashboard()} />
      }}
    </Query>
  )
}

export default SlackSignInSuccess



// WEBPACK FOOTER //
// ./src/components/SlackSignInSuccess.jsx